import './css/App.css';

export default function Footer() {

    return(
        <main id='footer' style={{overflow:"hidden"}} className='px-5'>
        <div>
        <hr/>
        <div className='row' style={{fontSize:"12px"}}>
        <span className='text-center'><a href="/">Home</a> | <a href="browse">Browse</a> | <a href="advanced">Advanced Search</a> | <a href="manual">Manual</a> | <a href="contact">Contact Us</a></span>
        </div>
        <div className='row' style={{fontSize:"12px"}}>
            <span className='text-center'>&copy; 2024, Lawrence Berkeley National Laboratory</span>
        </div>
        </div>
        </main>
    )
}